var React = require('react');

function Truck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M25.526 9c.416 0 .789.258.936.647l1.474 3.911c.042.113.064.233.064.353V20c0 .552-.448 1-1 1h-2.05c-.232 1.141-1.24 2-2.45 2-1.21 0-2.218-.859-2.45-2h-9.1c-.232 1.141-1.24 2-2.45 2-1.21 0-2.218-.859-2.45-2H5c-.552 0-1-.448-1-1v-1c0-.552.448-1 1-1h14v-8c0-.552.448-1 1-1h5.526zm-1.238 2H21.5v3h3.775c.091-.034.151-.072.18-.114.022-.031.035-.079.042-.143l.003-.069-.794-2.416c-.028-.088-.076-.153-.142-.197-.065-.044-.158-.064-.276-.06z"}));
}

Truck.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Truck;

Truck.default = Truck;
